module.exports = __webpack_public_path__ + "static/media/github.9cab3941.png";